import { Heart } from "lucide-react";

/**
 * Tap-heart pop overlay + the keyframes it needs. Kept together so the
 * animation definition can't drift out of sync with the render.
 */
export default function LiveRoomHearts({ hearts }) {
  return (
    <>
      {hearts.map((h) => (
        <div
          key={h.id}
          className="absolute pointer-events-none z-30 text-rose-500 text-3xl"
          style={{
            left: `${h.x}px`,
            top: `${h.y}px`,
            transform: "translate(-50%, -50%)",
            animation: "pandax-heart-pop 1.8s ease-out forwards",
          }}
        >
          <Heart className="fill-rose-500" size={30} />
        </div>
      ))}
      <style>{`
        @keyframes pandax-heart-pop {
          0%   { transform: translate(-50%, -50%) scale(0.4); opacity: 0.9; }
          20%  { transform: translate(-50%, -80%) scale(1.4); opacity: 1; }
          100% { transform: translate(-50%, -260%) scale(0.8); opacity: 0; }
        }
      `}</style>
    </>
  );
}
